<h1>Create Account</h1>

<div>
    Username:
    <input placeholder="MyUsername" [(ngModel)]="model.username"/>
</div>

<div>
    Full Name:
    <input placeholder="John Smith" [(ngModel)]="model.full_name"/>
</div>

<div>
    Email Address:
    <input type="email" placeholder="johnsmith@example.com" [(ngModel)]="model.email"/>
</div>

<div>
    Password:
    <input type="password" placeholder="password" [(ngModel)]="model.password"/>
</div>

<div>
    Confirm Password:
    <input type="password" placeholder="password" [(ngModel)]="confirm_password"/>
</div>

<p style="font-size: 0.7em;">We don't have an explicit Privacy Policy or Terms of Service yet since this project is for a hackathon. But by creating an account you agree to giving us access to any data you produce/submit on the website, and the rights to use it. It won't be shared with 3rd parties other than Discord.</p>

<p class="err-text" *ngIf="show_error">{{error_text}}</p>

<button class="flat-button" style="float: right; margin-top: 10px;" (click)="createAccountPressed()" [disabled]="is_loading">Create Account</button>